<!--
 * @Name: 红包弹窗
 * @Date: 2020-07-23 10:50:40
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-24 10:24:27
 * @FilePath: \car-demo\src\components\Packet.vue
-->
<template>
  <nut-dialog
      customClass="packet-modal"
      :visible="visible"
      :noFooter="true"
      @close="handleClose"
  >
    <img
        v-show="!isOpened"
        class="init"
        src="../assets/images/red-packet-init.png"
        alt="..."
        @click="handleOpen"
    />

    <div class="packet-box">
      <!-- 红包金额 -->
      <span class="text" v-if="current >= 0 && status[current] == 'success'">{{money}}</span>
      <img
          v-show="isOpened"
          class="next"
          :src="imgSrc"
          alt="恭喜您获得66.66元"
      />
    </div>

    <a class="close-btn" @click="handleClose"
    ><img src="../assets/images/packet_close.png" alt="..."
    /></a>
  </nut-dialog>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Packet',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: Boolean,
    hongboaid: 0,
  },
  data: () => ({
    isOpened: false, // 红包是否已被拆开
    status: ['success', 'done', 'late'], // 红包的三种状态
    current: -1,
    money: 0,
    imgSrc: require(`../assets/images/red-packet-init.png`),
  }),
  methods: {
    handleClose() {
      this.$emit('change', false)
    },

    // 拆红包
    handleOpen() {

      anime({
        targets: '.packet-modal .init',
        rotateY: {
          value: '1turn',
          duration: 1500,
          easing: 'easeOutQuart',
        },
        opacity: {
          value: 0,
          delay: 1000,
          easing: 'linear',
        },
      })

      let index = 2
      this.$ajax.get('m/hongbao/hongbao_receive', {
        id: this.hongboaid,
      }).then((res) => {
        if (res.rescode == 1) {
          index = 0
        } else {
          index = 2
        }
        this.hongbao_money = res.result;
        this.hongbao_msg = res.msg;
        this.current = 0;
        this.money = res.result;
        this.imgSrc = require(`../assets/images/red-packet-${this.status[index]}.png`);
        this.isOpened = true

        anime({
          targets: '.next',
          scale: [0, 1],
          opacity: [0, 1],
          zIndex: 1,
        })

      })
    },

    animeDh() {

    }
  },
}
</script>

<style scoped lang="less">
.packet-modal {
  & /deep/ .nut-dialog {
    background-color: transparent;
  }

  & /deep/ .nut-dialog-body {
    padding: 0;
  }

  & /deep/ .nut-dialog-content {
    padding-bottom: 0;
  }

  img {
    width: 100%;
  }

  // 恭喜您获得 xx 元
  .packet-box {
    position: relative;

    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-65%, -100%);
      margin-top: -15px;
      z-index: 99;
      color: #e9493d;
      font-size: 38px;
    }
  }

  .close-btn {
    position: relative;
    top: -15px;

    img {
      width: 26px;
      height: 26px;
    }
  }
}
</style>
